/**
 * Fix GD (2026-10-14): "una columna de referencia con el % de ingresos que tiene cada obra" · "esa misma
 * columna de referencia debería estar cuando se valida la imputación de los costos directos a los
 * centros de costos" (CEN). Ingresos = certificaciones emitidas, pagadas o vencidas (neto sin IVA):
 * las del período y, si no hay, las acumuladas.
 */
import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../contexts/AuthContext";

export function pctFmt(n) {
  return String(Math.round(Number(n || 0) * 100) / 100).replace(".", ",");
}

export function useIngresosObras(dateFrom, dateTo, activo = true) {
  const [datos, setDatos] = useState(null);
  useEffect(() => {
    if (!activo) return undefined;
    let vivo = true;
    axios.get(`${API}/hr/parte-diario/ingresos-obras`,
      { params: { date_from: dateFrom || undefined, date_to: dateTo || undefined }, withCredentials: true })
      .then(r => { if (vivo) setDatos(r.data); })
      .catch(() => { if (vivo) setDatos(null); });
    return () => { vivo = false; };
  }, [dateFrom, dateTo, activo]);
  return datos;
}

// presupuesto_id (base o adicional) -> % de ingresos de su obra; sin certificaciones no hay referencia.
export function pctPorPto(datos) {
  const m = {};
  if (!datos || datos.base === "sin_datos") return m;
  (datos.obras || []).forEach(o => (o.presupuesto_ids || []).forEach(p => { m[p] = o.ingresos_pct; }));
  return m;
}

export function leyendaIngresos(base) {
  if (base === "periodo") return "certificaciones emitidas en el período";
  if (base === "acumulado") return "certificaciones emitidas acumuladas (no hay en el período)";
  return "todavía no hay certificaciones emitidas";
}

export default function IngresosObras({ datos, testid = "ingresos-obras" }) {
  if (!datos) return null;
  const obras = datos.obras || [];
  return (
    <div className="bg-sky-50 border border-sky-100 rounded-xl px-4 py-3" data-testid={testid}>
      <p className="text-xs font-bold text-sky-800 uppercase tracking-wide">
        % de ingresos por obra <span className="font-normal normal-case text-sky-700/80">· {leyendaIngresos(datos.base)}</span>
      </p>
      {obras.length === 0 ? (
        <p className="text-xs text-sky-700/80 mt-1">No hay obras activas.</p>
      ) : (
        <div className="flex flex-wrap gap-2 mt-2">
          {obras.map(o => (
            <span key={o.obra_id} className="bg-white border border-sky-200 rounded-lg px-2.5 py-1 text-xs text-gray-700" data-testid={`${testid}-${o.obra_id}`}>
              {o.nombre} <b className="text-sky-800 tabular-nums">{pctFmt(o.ingresos_pct)} %</b>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
